"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pill = void 0;
var _react = _interopRequireDefault(require("react"));
var _ripple = require("../ripple");
var _IconAble = require("../svg/IconAble");
var _utility = require("../utility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Pill = /*#__PURE__*/function (_React$Component) {
  _inherits(Pill, _React$Component);
  var _super = _createSuper(Pill);
  function Pill(props) {
    var _this;
    _classCallCheck(this, Pill);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "renderPill", function () {
      var outerClassName;
      var innerLabelClass;
      var _this$props = _this.props,
        variant = _this$props.variant,
        isDisabled = _this$props.isDisabled,
        isActive = _this$props.isActive,
        id = _this$props.id,
        className = _this$props.className,
        onClick = _this$props.onClick;
      var _this$props$ripple = _this.props.ripple,
        ripple = _this$props$ripple === void 0 ? true : _this$props$ripple;
      if (isDisabled) {
        outerClassName = 'tl-disabled';
        innerLabelClass = 'tl-pill-disabled';
        ripple = false;
      } else {
        if (isActive) {
          if (variant === 'primary') {
            outerClassName = 'tl-active primary';
            innerLabelClass = 'tl-pill-active primary';
          } else {
            outerClassName = 'tl-active';
            innerLabelClass = 'tl-pill-active';
          }
        } else {
          if (variant === 'primary') {
            outerClassName = 'tl-inactive primary';
            innerLabelClass = 'tl-pill-inactive primary';
          } else {
            outerClassName = 'tl-inactive';
            innerLabelClass = 'tl-pill-inactive';
          }
        }
      }
      var areaClassName = '';
      if (variant === 'input') {
        areaClassName = "tl-pill-".concat(variant, "-variant");
        if (onClick === undefined) {
          ripple = false;
        }
      }
      outerClassName = outerClassName + " tl-pill-advanced tl-pill-".concat(variant);
      return /*#__PURE__*/_react.default.createElement("button", {
        onKeyUp: isDisabled ? undefined : _this.onPillClick,
        id: id,
        "aria-pressed": isActive ? 'true' : 'false',
        disabled: isDisabled || variant === 'input',
        onClick: isDisabled ? undefined : _this.handleClick,
        className: (0, _utility.classNames)('tl-ui', 'tl-pill-area', areaClassName, isDisabled && 'disabled')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "tl-pill-content tl-pill-value tl-pill-advanced ".concat(outerClassName, " ").concat(className ? className : "")
      }, ripple && /*#__PURE__*/_react.default.createElement(_ripple.Ripple, {
        className: "tl-pill-ripple"
      }), _this.renderTypedPill(), _this.getPillContent(innerLabelClass)));
    });
    _defineProperty(_assertThisInitialized(_this), "handleInputAction", function (e) {
      var _this$props2 = _this.props,
        onCancel = _this$props2.onCancel,
        id = _this$props2.id,
        index = _this$props2.index;
      e.stopPropagation();
      onCancel && onCancel(e, {
        id: id,
        index: index
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onPillClick", function (event) {
      var _this$props3 = _this.props,
        onClick = _this$props3.onClick,
        index = _this$props3.index;
      _this.setState({
        focusClass: ''
      });
      if (event.key === "Enter") {
        onClick && onClick(index, event);
      }
    });
    _this.state = {
      focusClass: 'tl-pill-onfocus'
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.onPillClick = _this.onPillClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Pill, [{
    key: "getPillContent",
    value: function getPillContent(classValue) {
      var pillLabel = ' ';
      if (this.props.label) {
        var minLength = Math.min(this.props.labelLengthTruncated ? this.props.labelLengthTruncated : 200, 200);
        pillLabel = this.props.label.length > minLength ? this.props.label.slice(0, minLength) + '...' : this.props.label;
      }
      var className = "tl-pill-label ".concat(classValue);
      return pillLabel && /*#__PURE__*/_react.default.createElement("span", {
        className: className
      }, pillLabel);
    }
  }, {
    key: "renderTypedPill",
    value: function renderTypedPill() {
      var _this$props4 = this.props,
        variant = _this$props4.variant,
        icon = _this$props4.icon,
        isDisabled = _this$props4.isDisabled;
      if (variant === 'assist') {
        return icon ? icon : /*#__PURE__*/_react.default.createElement(_IconAble.IconAble, {
          icon: 'Plus'
        });
      } else if (variant === 'input') {
        return /*#__PURE__*/_react.default.createElement("button", {
          disabled: isDisabled,
          title: "Cancel",
          tabIndex: 0,
          onMouseOver: function onMouseOver(e) {
            return e.stopPropagation();
          },
          onClick: this.handleInputAction,
          className: "tl-icon-button"
        }, /*#__PURE__*/_react.default.createElement(_IconAble.IconAble, {
          icon: 'Close'
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderPill();
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props5 = this.props,
        onClick = _this$props5.onClick,
        index = _this$props5.index;
      this.setState({
        focusClass: 'tl-pill-onfocus'
      });
      onClick && onClick(index, e);
      ;
    }
  }]);
  return Pill;
}(_react.default.Component);
exports.Pill = Pill;
_defineProperty(Pill, "defaultProps", {
  label: ''
});